module.exports = __webpack_public_path__ + "media/images/histogram-06d009eb177acfed5c8032ae4346ff32.svg";